import React from "react";
import { Grid } from "@mui/material";
import "./northCarolina.scss";
import {
  INSTALLED_ALTERED_RELOCATED_REMOVED,
  TEMPORARY_OR_PERMANENT,
  TIME_LIMIT_FOR_GROUND_COVER,
  YES_NO,
} from "../../../../../constant/constant";
import FormControl from "@mui/material/FormControl";
import SelectMenu from "../../../../../library/custom/selectMenu/SelectMenu";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import {
  generateInspectionGroundStabilization,
  generateSwInspectionLotDisturbance,
  generateSwInspectionNewOrRevisedMeasures,
  generateSwInspectionObservation,
} from "../../../../../utils/swInspectionHelper";
import Button from "../../../../../library/custom/button/Button";
import { getFormatedDate, parseDate } from "../../../../../utils/helper";
import DatePicker from "../../../../../library/custom/datePicker/DatePicker";

const NorthCarolina = (props) => {
  const twoQuesHandler = (value, insCQ) => {
    const confAns = value;
    props?.propsData?.setSwInspectionConfQuestionAns((prevState) => {
      const existingQuestion = prevState.find(
        (item) => item.confQuesId === insCQ.key
      );
      if (existingQuestion) {
        return prevState.map((item) =>
          item.confQuesId === insCQ.key ? { ...item, confAns: confAns } : item
        );
      } else {
        return [
          ...prevState,
          {
            confQuesId: insCQ.key,
            confAns: confAns,
          },
        ];
      }
    });
  };

  const addMoreInspectionGroundStabilization = () => {
    const newObjects = generateInspectionGroundStabilization(5);
    props?.propsData?.setSwInspectionGroundStabilization((prevState) => [
      ...prevState,
      ...newObjects,
    ]);
  };

  const groundStabilizationHandler = (
    index,
    area,
    timeLimit,
    isStabilizationInstalled,
    stabilization,
    groundCover,
    inspectionDate,
    describeAction,
    dateCorrecion
  ) => {
    props?.propsData?.setSwInspectionGroundStabilization((prevState) => {
      const updatedData = [...prevState];
      updatedData[index] = {
        ...updatedData[index],
        area: area,
        timeLimit: timeLimit,
        isStabilizationInstalled: isStabilizationInstalled,
        stabilization: stabilization,
        groundCover: groundCover,
        inspectionDate: inspectionDate
          ? parseDate(inspectionDate, "MM-dd-yyyy")
          : "",
        describeAction: describeAction,
        dateCorrecion: dateCorrecion
          ? parseDate(dateCorrecion, "MM-dd-yyyy")
          : "",
      };

      return updatedData;
    });
  };

  const addMoreSwInspectionObservation = () => {
    const newObjects = generateSwInspectionObservation(5);
    props?.propsData?.setSwInspectionObservation((prevState) => [
      ...prevState,
      ...newObjects,
    ]);
  };

  const swInspectionObservationHandler = (
    index,
    dischargeOutfall,
    anyIncreaseInStream,
    anyVisibleOil,
    anyVisibleErosion,
    anyVisibleSedimentation,
    inspectionDate,
    recommendation,
    dateCorrection
  ) => {
    props?.propsData?.setSwInspectionObservation((prevState) => {
      const updatedData = [...prevState];

      updatedData[index] = {
        ...updatedData[index],
        dischargeOutfall,
        anyIncreaseInStream,
        anyVisibleOil,
        anyVisibleErosion,
        inspectionDate,
        anyVisibleSedimentation,
        recommendation,
        dateCorrection,
      };

      return updatedData;
    });
  };

  const addMoreSwInspectionLotDisturbance = () => {
    const newObjects = generateSwInspectionLotDisturbance(5);
    props?.propsData?.setSwInspectionLotDisturbance((prevState) => [
      ...prevState,
      ...newObjects,
    ]);
  };

  const addMoreSwInspectionNewOrRevisedMeasures = () => {
    const newObjects = generateSwInspectionNewOrRevisedMeasures(5);
    props?.propsData?.setSwInspectionNewOrRevisedMeasures((prevState) => [
      ...prevState,
      ...newObjects,
    ]);
  };
  const swInspectionLotDisturbanceHandler = (
    index,
    lotNumber,
    disturbanceDate,
    erosionControlDate
  ) => {
    props?.propsData?.setSwInspectionLotDisturbance((prevState) => {
      const updatedData = [...prevState];

      updatedData[index] = {
        ...updatedData[index],
        lotNumber: lotNumber,
        disturbanceDate: disturbanceDate
          ? parseDate(disturbanceDate, "MM-dd-yyyy")
          : "",
        erosionControlDate: erosionControlDate
          ? parseDate(erosionControlDate, "MM-dd-yyyy")
          : "",
      };

      return updatedData;
    });
  };

  const swInspectionNewOrRevisedMeasuresHandler = (
    index,
    locationAndDesc,
    proposedDimension,
    actualDimension,
    significantDeviation,
    measureDate,
    measureType
  ) => {
    props?.propsData?.setSwInspectionNewOrRevisedMeasures((prevState) => {
      const updatedData = [...prevState];

      updatedData[index] = {
        ...updatedData[index],
        locationAndDesc: locationAndDesc,
        proposedDimension: proposedDimension,
        actualDimension: actualDimension,
        significantDeviation: significantDeviation,
        measureDate: measureDate ? parseDate(measureDate, "MM-dd-yyyy") : "",
        measureType: measureType,
      };

      return updatedData;
    });
  };

  const allQuestionsAnswered =
    props?.propsData?.getSwReference?.InsConfQuesList?.slice(0, 2)?.every(
      (insCQ) =>
        props?.propsData?.swInspectionConfQuestionAns?.some(
          (item) => item.confQuesId === insCQ.key && item.confAns
        )
    );

  return (
    <>
      <Grid item md={12} className="northCarolinaOverride">
        <div className="twoQuestionBox">
          {props?.propsData?.getSwReference?.InsConfQuesList?.slice(0, 2)?.map(
            (insCQ) => {
              const selectedAnswer =
                props?.propsData?.swInspectionConfQuestionAns?.find(
                  (item) => item.confQuesId === insCQ.key
                )?.confAns;
              return (
                <div className="twoQuestionList" key={insCQ?.key}>
                  <Grid item md={7} xs={12}>
                    <FormControl fullWidth>
                      <FormLabels label={insCQ?.value} isRequired={true} />
                      <SelectMenu
                        placeholder="Please Select"
                        listData={YES_NO ?? []}
                        value={selectedAnswer ?? ""}
                        onchangehandler={(e) =>
                          twoQuesHandler(e.target.value, insCQ)
                        }
                      />
                    </FormControl>
                  </Grid>
                </div>
              );
            }
          )}
          {!allQuestionsAnswered && props?.propsData?.twoQuestionError && (
            <Grid item md={12} mb={2}>
              <p className="error">
                Please answer all required inspection confirmation questions.
              </p>
            </Grid>
          )}
        </div>

        <div className="commonTableBoxNorth">
          <div className="commonTableBoxNorthTitle">
            Ground Stabilization: Must be recorded after each phase of grading
          </div>
          <div className="tableWrapper">
            <table>
              <tr className="tableHead">
                <th>
                  Site area description and location where activities have
                  temporarily or permanently ceased
                </th>
                <th>Time Limit for Ground Cover 7 days or 14 days</th>
                <th>Have stabilization measures been installed?</th>
                <th>Temporary or Permanent Stabilization</th>
                <th>Ground Cover Sufficient to Restrain Erosion?(Y/N)</th>
                <th>Original Inspection Date</th>
                <th>Describe Actions Needed</th>
                <th>Date Corrections Verified</th>
              </tr>

              {props?.propsData?.swInspectionGroundStabilization?.map(
                (groundStabilization, index) => {
                  return (
                    <tr className="tableBody" key={groundStabilization?.id}>
                      <td>
                        <InputField
                          isRequired={false}
                          type="text"
                          placeholder={"Enter Here..."}
                          value={groundStabilization?.area || ""}
                          onChange={(e) =>
                            groundStabilizationHandler(
                              index,
                              e?.target?.value,
                              groundStabilization?.timeLimit,
                              groundStabilization?.isStabilizationInstalled,
                              groundStabilization?.stabilization,
                              groundStabilization?.groundCover,
                              groundStabilization?.inspectionDate,
                              groundStabilization?.describeAction,
                              groundStabilization?.dateCorrecion,
                              groundStabilization?.id
                            )
                          }
                        />
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={TIME_LIMIT_FOR_GROUND_COVER ?? []}
                            value={groundStabilization?.timeLimit}
                            onchangehandler={(e) =>
                              groundStabilizationHandler(
                                index,
                                groundStabilization?.area,
                                e?.target?.value,
                                groundStabilization?.isStabilizationInstalled,
                                groundStabilization?.stabilization,
                                groundStabilization?.groundCover,
                                groundStabilization?.inspectionDate,
                                groundStabilization?.describeAction,
                                groundStabilization?.dateCorrecion,
                                groundStabilization?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={YES_NO ?? []}
                            value={
                              groundStabilization?.isStabilizationInstalled
                            }
                            onchangehandler={(e) =>
                              groundStabilizationHandler(
                                index,
                                groundStabilization?.area,
                                groundStabilization?.timeLimit,
                                e?.target?.value,
                                groundStabilization?.stabilization,
                                groundStabilization?.groundCover,
                                groundStabilization?.inspectionDate,
                                groundStabilization?.describeAction,
                                groundStabilization?.dateCorrecion,
                                groundStabilization?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={TEMPORARY_OR_PERMANENT ?? []}
                            value={groundStabilization?.stabilization}
                            onchangehandler={(e) =>
                              groundStabilizationHandler(
                                index,
                                groundStabilization?.area,
                                groundStabilization?.timeLimit,
                                groundStabilization?.isStabilizationInstalled,
                                e?.target?.value,
                                groundStabilization?.groundCover,
                                groundStabilization?.inspectionDate,
                                groundStabilization?.describeAction,
                                groundStabilization?.dateCorrecion,
                                groundStabilization?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={YES_NO ?? []}
                            value={groundStabilization?.groundCover}
                            onchangehandler={(e) =>
                              groundStabilizationHandler(
                                index,
                                groundStabilization?.area,
                                groundStabilization?.timeLimit,
                                groundStabilization?.isStabilizationInstalled,
                                groundStabilization?.stabilization,
                                e?.target?.value,
                                groundStabilization?.inspectionDate,
                                groundStabilization?.describeAction,
                                groundStabilization?.dateCorrecion,
                                groundStabilization?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <DatePicker
                          onChangeHandler={(e) =>
                            groundStabilizationHandler(
                              index,
                              groundStabilization?.area,
                              groundStabilization?.timeLimit,
                              groundStabilization?.isStabilizationInstalled,
                              groundStabilization?.stabilization,
                              groundStabilization?.groundCover,
                              e,
                              groundStabilization?.describeAction,
                              groundStabilization?.dateCorrecion,
                              groundStabilization?.id
                            )
                          }
                          value={
                            parseDate(
                              groundStabilization?.inspectionDate,
                              "MM-dd-yyyy"
                            ) ?? ""
                          }
                          maxDateEnable={false}
                        />
                      </td>
                      <td>
                        <InputField
                          isRequired={false}
                          type="text"
                          placeholder={"Enter Here..."}
                          value={groundStabilization?.describeAction || ""}
                          onChange={(e) =>
                            groundStabilizationHandler(
                              index,
                              groundStabilization?.area,
                              groundStabilization?.timeLimit,
                              groundStabilization?.isStabilizationInstalled,
                              groundStabilization?.stabilization,
                              groundStabilization?.groundCover,
                              groundStabilization?.inspectionDate,
                              e?.target?.value,
                              groundStabilization?.dateCorrecion,
                              groundStabilization?.id
                            )
                          }
                        />
                      </td>
                      <td>
                        <DatePicker
                          onChangeHandler={(e) =>
                            groundStabilizationHandler(
                              index,
                              groundStabilization?.area,
                              groundStabilization?.timeLimit,
                              groundStabilization?.isStabilizationInstalled,
                              groundStabilization?.stabilization,
                              groundStabilization?.groundCover,
                              groundStabilization?.inspectionDate,
                              groundStabilization?.describeAction,
                              e,
                              groundStabilization?.id
                            )
                          }
                          value={
                            parseDate(
                              groundStabilization?.dateCorrecion,
                              "MM-dd-yyyy"
                            ) ?? ""
                          }
                          maxDateEnable={false}
                        />
                      </td>
                    </tr>
                  );
                }
              )}
            </table>
          </div>
          <Grid container mt={2}>
            <Button
              varientTextGreen={true}
              label={"Add More Rows"}
              onClick={addMoreInspectionGroundStabilization}
            />
          </Grid>
        </div>

        <div className="commonTableBoxNorth">
          <div className="commonTableBoxNorthTitle">
            Stormwater Discharge Outfalls
          </div>
          <div className="tableWrapper">
            <table>
              <tr className="tableHead">
                <th>Stormwater Discharge Outfall ID or Location</th>

                <th>Any Increase in Stream Turbidity from Discharge?</th>
                <th>
                  Any visible oil sheen, floating or suspended solids or
                  discoloration?
                </th>
                <th>Any Visible Erosion below SDO?</th>
                <th>
                  Any Visible Sedimentation in Streams, Wetlands or Outside Site
                  Limits?
                </th>
                <th>Inspection Date</th>
                <th>Describe Actions Needed</th>
                <th>Date Corrections Verified</th>
              </tr>

              {props?.propsData?.swInspectionObservation?.map(
                (inspectionObservation, index) => {
                  return (
                    <tr className="tableBody" key={inspectionObservation?.id}>
                      <td>
                        <InputField
                          isRequired={false}
                          type="text"
                          placeholder={"Enter Here..."}
                          value={inspectionObservation?.dischargeOutfall || ""}
                          onChange={(e) =>
                            swInspectionObservationHandler(
                              index,
                              e?.target?.value,
                              inspectionObservation?.anyIncreaseInStream,
                              inspectionObservation?.anyVisibleOil,
                              inspectionObservation?.anyVisibleErosion,
                              inspectionObservation?.anyVisibleSedimentation,
                              inspectionObservation?.inspectionDate,
                              inspectionObservation?.recommendation,
                              inspectionObservation?.dateCorrection,
                              inspectionObservation?.id
                            )
                          }
                        />
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={YES_NO ?? []}
                            value={inspectionObservation?.anyIncreaseInStream}
                            onchangehandler={(e) =>
                              swInspectionObservationHandler(
                                index,
                                inspectionObservation?.dischargeOutfall,
                                e?.target?.value,
                                inspectionObservation?.anyVisibleOil,
                                inspectionObservation?.anyVisibleErosion,
                                inspectionObservation?.anyVisibleSedimentation,
                                inspectionObservation?.inspectionDate,
                                inspectionObservation?.recommendation,
                                inspectionObservation?.dateCorrection,
                                inspectionObservation?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={YES_NO ?? []}
                            value={inspectionObservation?.anyVisibleOil}
                            onchangehandler={(e) =>
                              swInspectionObservationHandler(
                                index,
                                inspectionObservation?.dischargeOutfall,
                                inspectionObservation?.anyIncreaseInStream,
                                e?.target?.value,
                                inspectionObservation?.anyVisibleErosion,
                                inspectionObservation?.anyVisibleSedimentation,
                                inspectionObservation?.inspectionDate,
                                inspectionObservation?.recommendation,
                                inspectionObservation?.dateCorrection,
                                inspectionObservation?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={YES_NO ?? []}
                            value={inspectionObservation?.anyVisibleErosion}
                            onchangehandler={(e) =>
                              swInspectionObservationHandler(
                                index,
                                inspectionObservation?.dischargeOutfall,
                                inspectionObservation?.anyIncreaseInStream,
                                inspectionObservation?.anyVisibleOil,
                                e?.target?.value,
                                inspectionObservation?.anyVisibleSedimentation,
                                inspectionObservation?.inspectionDate,
                                inspectionObservation?.recommendation,
                                inspectionObservation?.dateCorrection,
                                inspectionObservation?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <FormControl fullWidth>
                          <SelectMenu
                            placeholder="Please Select"
                            listData={YES_NO ?? []}
                            value={
                              inspectionObservation?.anyVisibleSedimentation
                            }
                            onchangehandler={(e) =>
                              swInspectionObservationHandler(
                                index,
                                inspectionObservation?.dischargeOutfall,
                                inspectionObservation?.anyIncreaseInStream,
                                inspectionObservation?.anyVisibleOil,
                                inspectionObservation?.anyVisibleErosion,
                                e?.target?.value,
                                inspectionObservation?.inspectionDate,
                                inspectionObservation?.recommendation,
                                inspectionObservation?.dateCorrection,
                                inspectionObservation?.id
                              )
                            }
                            clearIcon={true}
                          />
                        </FormControl>
                      </td>
                      <td>
                        <DatePicker
                          onChangeHandler={(e) =>
                            swInspectionObservationHandler(
                              index,
                              inspectionObservation?.dischargeOutfall,
                              inspectionObservation?.anyIncreaseInStream,
                              inspectionObservation?.anyVisibleOil,
                              inspectionObservation?.anyVisibleErosion,
                              inspectionObservation?.anyVisibleSedimentation,
                              e,
                              inspectionObservation?.recommendation,
                              inspectionObservation?.dateCorrection,
                              inspectionObservation?.id
                            )
                          }
                          value={
                            parseDate(
                              inspectionObservation?.inspectionDate,
                              "MM-dd-yyyy"
                            ) ?? ""
                          }
                          maxDateEnable={false}
                        />
                      </td>
                      <td>
                        <InputField
                          isRequired={false}
                          type="text"
                          placeholder={"Enter Here..."}
                          value={inspectionObservation?.recommendation || ""}
                          onChange={(e) =>
                            swInspectionObservationHandler(
                              index,
                              inspectionObservation?.dischargeOutfall,
                              inspectionObservation?.anyIncreaseInStream,
                              inspectionObservation?.anyVisibleOil,
                              inspectionObservation?.anyVisibleErosion,
                              inspectionObservation?.anyVisibleSedimentation,
                              inspectionObservation?.inspectionDate,
                              e?.target?.value,
                              inspectionObservation?.dateCorrection,
                              inspectionObservation?.id
                            )
                          }
                        />
                      </td>
                      <td>
                        <DatePicker
                          onChangeHandler={(e) =>
                            swInspectionObservationHandler(
                              index,
                              inspectionObservation?.dischargeOutfall,
                              inspectionObservation?.anyIncreaseInStream,
                              inspectionObservation?.anyVisibleOil,
                              inspectionObservation?.anyVisibleErosion,
                              inspectionObservation?.anyVisibleSedimentation,
                              inspectionObservation?.inspectionDate,
                              inspectionObservation?.recommendation,
                              e,
                              inspectionObservation?.id
                            )
                          }
                          value={
                            parseDate(
                              inspectionObservation?.dateCorrection,
                              "MM-dd-yyyy"
                            ) ?? ""
                          }
                          maxDateEnable={false}
                        />
                      </td>
                    </tr>
                  );
                }
              )}
            </table>
          </div>
          <Grid container mt={2}>
            <Button
              varientTextGreen={true}
              label={"Add More Rows"}
              onClick={addMoreSwInspectionObservation}
            />
          </Grid>
        </div>
        {!props?.propsData?.isSouthCarolina && (
          <div className="commonTableBoxNorth">
            <div className="commonTableBoxNorthTitle">
              New or Revised Measures
            </div>
            <div className="tableWrapper">
              <table>
                <tr className="tableHead">
                  <th>Measure ID or Location and Description</th>
                  <th>Proposed Dimensions</th>
                  <th>Actual Dimensions (ft)</th>
                  <th>Significant Deviation from plan?</th>
                  <th>
                    Date Measure observed as installed, altered, relocated, or
                    removed.
                  </th>
                  <th>Installed, Altered, Relocated, or Removed.</th>
                </tr>

                {props?.propsData?.swInspectionNewOrRevisedMeasures?.map(
                  (newOrRevisedMeasures, index) => {
                    return (
                      <tr className="tableBody" key={newOrRevisedMeasures?.id}>
                        <td>
                          <InputField
                            isRequired={false}
                            type="text"
                            placeholder={"Enter Here..."}
                            value={newOrRevisedMeasures?.locationAndDesc || ""}
                            onChange={(e) =>
                              swInspectionNewOrRevisedMeasuresHandler(
                                index,
                                e?.target?.value,
                                newOrRevisedMeasures?.proposedDimension,
                                newOrRevisedMeasures?.actualDimension,
                                newOrRevisedMeasures?.significantDeviation,
                                newOrRevisedMeasures?.measureDate,
                                newOrRevisedMeasures?.measureType,
                                newOrRevisedMeasures?.id
                              )
                            }
                          />
                        </td>

                        <td>
                          <InputField
                            isRequired={false}
                            type="text"
                            placeholder={"Enter Here..."}
                            value={
                              newOrRevisedMeasures?.proposedDimension || ""
                            }
                            onChange={(e) =>
                              swInspectionNewOrRevisedMeasuresHandler(
                                index,
                                newOrRevisedMeasures?.locationAndDesc,
                                e?.target?.value,
                                newOrRevisedMeasures?.actualDimension,
                                newOrRevisedMeasures?.significantDeviation,
                                newOrRevisedMeasures?.measureDate,
                                newOrRevisedMeasures?.measureType,
                                newOrRevisedMeasures?.id
                              )
                            }
                          />
                        </td>

                        <td>
                          <InputField
                            isRequired={false}
                            type="text"
                            placeholder={"Enter Here..."}
                            value={newOrRevisedMeasures?.actualDimension || ""}
                            onChange={(e) =>
                              swInspectionNewOrRevisedMeasuresHandler(
                                index,
                                newOrRevisedMeasures?.locationAndDesc,
                                newOrRevisedMeasures?.proposedDimension,
                                e?.target?.value,
                                newOrRevisedMeasures?.significantDeviation,
                                newOrRevisedMeasures?.measureDate,
                                newOrRevisedMeasures?.measureType,
                                newOrRevisedMeasures?.id
                              )
                            }
                          />
                        </td>

                        <td>
                          <FormControl fullWidth>
                            <SelectMenu
                              placeholder="Please Select"
                              listData={YES_NO ?? []}
                              value={newOrRevisedMeasures?.significantDeviation}
                              onchangehandler={(e) =>
                                swInspectionNewOrRevisedMeasuresHandler(
                                  index,
                                  newOrRevisedMeasures?.locationAndDesc,
                                  newOrRevisedMeasures?.proposedDimension,
                                  newOrRevisedMeasures?.actualDimension,
                                  e?.target?.value,
                                  newOrRevisedMeasures?.measureDate,
                                  newOrRevisedMeasures?.measureType,
                                  newOrRevisedMeasures?.id
                                )
                              }
                              clearIcon={true}
                            />
                          </FormControl>
                        </td>

                        <td>
                          <DatePicker
                            onChangeHandler={(e) =>
                              swInspectionNewOrRevisedMeasuresHandler(
                                index,
                                newOrRevisedMeasures?.locationAndDesc,
                                newOrRevisedMeasures?.proposedDimension,
                                newOrRevisedMeasures?.actualDimension,
                                newOrRevisedMeasures?.significantDeviation,
                                e,
                                newOrRevisedMeasures?.measureType,
                                newOrRevisedMeasures?.id
                              )
                            }
                            value={
                              parseDate(
                                newOrRevisedMeasures?.measureDate,
                                "MM-dd-yyyy"
                              ) || ""
                            }
                            maxDateEnable={false}
                          />
                        </td>

                        <td>
                          <FormControl fullWidth>
                            <SelectMenu
                              placeholder="Please Select"
                              listData={
                                INSTALLED_ALTERED_RELOCATED_REMOVED ?? []
                              }
                              value={newOrRevisedMeasures?.measureType}
                              onchangehandler={(e) =>
                                swInspectionNewOrRevisedMeasuresHandler(
                                  index,
                                  newOrRevisedMeasures?.locationAndDesc,
                                  newOrRevisedMeasures?.proposedDimension,
                                  newOrRevisedMeasures?.actualDimension,
                                  newOrRevisedMeasures?.significantDeviation,
                                  newOrRevisedMeasures?.measureDate,
                                  e?.target?.value,
                                  newOrRevisedMeasures?.id
                                )
                              }
                              clearIcon={true}
                            />
                          </FormControl>
                        </td>
                      </tr>
                    );
                  }
                )}
              </table>
            </div>
            <Grid container mt={2}>
              <Button
                varientTextGreen={true}
                label={"Add More Rows"}
                onClick={addMoreSwInspectionNewOrRevisedMeasures}
              />
            </Grid>
          </div>
        )}

        <div className="commonTableBoxNorth">
          <div className="commonTableBoxNorthTitle">
            Individual Lot Disturbance
          </div>
          <div className="tableWrapper">
            <table>
              <tr className="tableHead">
                <th>Lot Number</th>
                <th>Date Lot Noted as Active</th>
                <th>Date Lot Noted as Stabilized</th>
              </tr>

              {props?.propsData?.swInspectionLotDisturbance?.map(
                (inspectionLotDisturbance, index) => {
                  return (
                    <tr
                      className="tableBody"
                      key={inspectionLotDisturbance?.id}
                    >
                      <td>
                        <InputField
                          isRequired={false}
                          type="text"
                          placeholder={"Enter Here..."}
                          value={inspectionLotDisturbance?.lotNumber || ""}
                          onChange={(e) =>
                            swInspectionLotDisturbanceHandler(
                              index,
                              e?.target?.value,
                              inspectionLotDisturbance?.disturbanceDate,
                              inspectionLotDisturbance?.erosionControlDate
                            )
                          }
                        />
                      </td>
                      <td>
                        <DatePicker
                          onChangeHandler={(e) =>
                            swInspectionLotDisturbanceHandler(
                              index,
                              inspectionLotDisturbance?.lotNumber,
                              e,
                              inspectionLotDisturbance?.erosionControlDate
                            )
                          }
                          value={
                            parseDate(
                              inspectionLotDisturbance?.disturbanceDate,
                              "MM-dd-yyyy"
                            ) || ""
                          }
                          maxDateEnable={false}
                        />
                      </td>
                      <td>
                        <DatePicker
                          onChangeHandler={(e) =>
                            swInspectionLotDisturbanceHandler(
                              index,
                              inspectionLotDisturbance?.lotNumber,
                              inspectionLotDisturbance?.disturbanceDate,
                              e
                            )
                          }
                          value={
                            parseDate(
                              inspectionLotDisturbance?.erosionControlDate,
                              "MM-dd-yyyy"
                            ) || ""
                          }
                          maxDateEnable={false}
                        />
                      </td>
                    </tr>
                  );
                }
              )}
            </table>
          </div>
          <Grid container mt={2}>
            <Button
              varientTextGreen={true}
              label={"Add More Rows"}
              onClick={addMoreSwInspectionLotDisturbance}
            />
          </Grid>
        </div>
      </Grid>
    </>
  );
};

export default NorthCarolina;
